import { useContext } from "react";
import widthContext from "../../context/widthContext";
import { motion } from "framer-motion";
import { LinksCard } from "../../components/Cards";

const Products = () => {
  const width = useContext(widthContext);
  const variants = {
    initial: {
      scale: 0.8,
      opacity: 0,
      x: 100,
    },
    animate: {
      scale: 1,
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <main className="flex flex-col gap-8 px-4  sm:px-8 lg:px-16 h-screen">
      <motion.h3
        variants={variants}
        initial="initial"
        animate="animate"
        className="font-medium text-2xl lg:text-6xl"
      >
        A seamless software <br /> to power your business.
      </motion.h3>
      <p className="text-xl sm:text-2xl sm:w-1/2">
        Process orders, accept payments, connect to logistic providers, engage
        with your customers… and more. We equip you with everything you need to
        grow your business.
      </p>
      <LinksCard text={"Request demo"} to={"/contact"} width={width} />
    </main>
  );
};

export default Products;
